module.exports = __webpack_public_path__ + "img/1.894ad38b.svg";